// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flag-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 14V3H4V14H8Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 16H20L18 10.5L20 5H13L11 3H8V14H11L13 16Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 3H11L13 5H20L18 10.5L20 16H13L11 14H4M4 3V14M4 3H8V14H4M4 14V21.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Flag2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-2',
    ref,
    icon: element,
  },
));

Flag2Icon.displayName = 'Flag2Icon';

export default Flag2Icon;
